import { inject, Injectable } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { TranslateService } from '@ngx-translate/core';
import { buildPrimeNgCalendarTranslation } from '../shared/utils/prime-ng-calendar-translation';

/**
 * Keeps PrimeNG (p-datepicker, etc.) labels in sync with @ngx-translate's active language.
 * Uses PrimeNG v21's `PrimeNG` service (replaces the old `PrimeNGConfig` from primeng/api).
 */
@Injectable({ providedIn: 'root' })
export class PrimeNgLocaleSyncService {
  private readonly config = inject(PrimeNG);
  private readonly translate = inject(TranslateService);

  constructor() {
    queueMicrotask(() => this.apply());
    this.translate.onLangChange.subscribe(() => this.apply());
  }

  private apply(): void {
    const lang = this.translate.currentLang || 'en';
    const t = this.translate.instant.bind(this.translate);
    this.config.setTranslation(
      buildPrimeNgCalendarTranslation(lang, {
        today: t('PAYLINK_APP.CALENDAR.TODAY') || 'Today',
        clear: t('PAYLINK_APP.CALENDAR.CLEAR') || 'Clear',
      })
    );
  }
}
